<template>
     <div class="col-lg-4" v-if="this.modalType == 'addItem' || (this.modalType == 'editItem' && this.modalForm.is_manuel != 2) || this.modalForm">
        <div class="card border border-gray-300 h-100 card-flush" id="kt_contacts_list" v-if="!this.isContactInfoVisible">
            <div class="card-header pt-3">
                <div class="card-title">
                    <h4 class="text-gray-800">
                        {{ $t('recently_used_accounts') }}
                    </h4> 
                </div>
                <div class="card-toolbar" v-if="this.modalForm.account_id !== null && this.modalForm.account_id !== '' && this.modalForm.account_id != '-1'">
                    <i class="bi bi-info-circle text-primary fs-3 ms-3 cursor-pointer" @click="this.isContactInfoVisible = !this.isContactInfoVisible;"></i>
                </div>                                                    
            </div>
            <div class="card-body p-5" id="kt_contacts_list_body">
                <div class="scroll-y me-n5 pe-5 mh-400px mh-lg-500px h-xl-auto" :class="{'mh-500px mh-lg-600px': this.modalType == 'addItem'}" v-if="this.recentlyUsedAccountsList">
                    <div class="card border-dashed mb-3" :class="{'border-gray-300 card-border-bottom-1': !item.isCollapsed, 'border-1 border-success': item.isCollapsed}" 
                        v-for="(item, index) in this.recentlyUsedAccountsList" v-bind:key="item">
                        <div class="card-body d-flex flex-stack p-2" v-if="item.id !== '-1'">
                            <div class="d-flex align-items-center cursor-pointer" @click="selectAccount(item)">
                                <div class="symbol symbol-40px symbol-circle cursor-pointer">
                                    <span v-if="this.modalForm.account_id !== item.id" class="symbol-label fs-6 fw-bolder">
                                        <a v-if="this.pageType != 1" href="#" class="btn btn-sm btn-icon text-hover-primary btn-circle border border-1 border-gray-200" 
                                            @click="openAccountReportModal(item)">
                                            <i class="fa fa-eye text-gray-600 fs-2"></i>
                                        </a>
                                        <a v-if="this.pageType == 1" href="#" class="btn btn-sm btn-icon text-hover-primary btn-circle border border-1 border-gray-200" 
                                            @click="openAccountReportModal(null, false, item)">
                                            <i class="fa fa-eye text-gray-600 fs-2"></i>
                                        </a>
                                    </span>
                                    <span v-if="this.modalForm.account_id == item.id" class="svg-icon svg-icon-success svg-icon-3x">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>
                                            <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor"/>
                                        </svg>
                                    </span>
                                </div>
                                <a class="ms-4 cursor-pointer">
                                    <span class="fs-6 fw-bold text-gray-800 text-hover-primary mb-2 cursor-pointer">
                                        {{item.name}}
                                    </span>
                                    <div class="fw-bold fs-7 text-muted cursor-pointer">{{item.account_type_name}}
                                        <span class="h-20px border-gray-400 border-start mx-3 mt-3"></span>
                                        <span v-if="this.modalForm.currency == this.localCurrency" class="fw-bold fs-7 text-muted cursor-pointer">
                                            {{item.local_balance}} {{this.localCurrency}}
                                        </span>
                                        <span v-if="this.modalForm.currency !== this.localCurrency" class="fw-bold fs-7 text-muted cursor-pointer">
                                            {{item.balance}} {{this.modalForm.currency}}
                                        </span>
                                    </div>
                                </a>
                            </div>
                            <div class="d-flex align-items-center">
                                <a class="fw-bold p-0 collapsible cursor-pointer rotate justify-content-end align-items-end shadow-sm rounded-1 collapsed border bg-light"
                                    data-bs-toggle="collapse" :data-bs-target="'#kt_account_'+index" @click="getAccountBalances(item)">
                                    <span class="svg-icon svg-icon-1 rotate-180">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z" fill="currentColor"></path>
                                        </svg>
                                    </span>
                                </a>
                            </div>
                        </div>
                        <div class="card-footer p-2 collapse" :id="'kt_account_' + index">
                            <div class="table-responsive">
                                <table class="table table-borderless mb-0 small">
                                    <thead>
                                        <tr class="text-gray-700 fw-bold">
                                            <th class="ps-3 py-2">{{$t('currency')}}</th>
                                            <th class="py-2 text-end">{{$t('balance')}}</th>
                                            <th class="py-2 text-end">{{localCurrency}} <br> {{$t('balance')}}</th>
                                            <th class="pe-3 text-end py-2">{{ $t('avg_due') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(i, index) in item.balances" v-bind:key="i">
                                            <td class="ps-3 p-0">
                                                <div class="d-flex justify-content-start align-items-center">
                                                    <div class="symbol symbol-25px symbol-circle">
                                                        <span class="symbol-label fs-8" :class="getRandomClass(index)">{{i.currency}}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="py-2 text-gray-600 text-end fw-medium">{{i.total_balance}}</td>
                                            <td class="py-2 text-gray-600 text-end fw-medium">{{i.total_balance_local}}</td>
                                            <td class="pe-3 py-2 border-bottom border-light">
                                                <div class="d-flex align-items-center justify-content-end">
                                                    <span class="text-gray-600 fw-medium">{{i.average_due_state}}</span>
                                                    <span class="text-muted ms-1 small" v-if="i.average_due_date !== null && i.average_due_date !== undefined && i.average_due_date !== ''">
                                                        ({{previewDate(i.average_due_date)}})
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="bg-light">
                                            <td class="ps-3 py-2" colspan="2">
                                                <span class="fw-bold text-gray-700">{{$t('total')}}</span>
                                            </td>
                                            <td class="py-2 text-gray-700 text-end fw-bold">{{getTotals(item.balances)}}</td>
                                            <td class="pe-3 py-2 text-gray-700 text-end fw-bold">{{item.totals.total_average_due_state}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card border border-gray-300 card-flush" v-if="this.isContactInfoVisible">
            <div class="card-header pt-3">
                <div class="card-title">
                    <h4 class="text-gray-800">
                        {{ $t('account_info') }}
                    </h4> 
                </div>
                <div class="card-toolbar m-0 p-0">
                    <i class="bi bi-x-lg fs-5 ms-3 cursor-pointer" @click="this.isContactInfoVisible = !this.isContactInfoVisible;"></i>
                </div>
            </div>
            <AccountInfo :selected-account-info="this.selectedAccount"></AccountInfo>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
// import $ from 'jquery';
export default {
    name: "RecentlyUsedAccounts",
    props:{
        modalType:String,
        modalForm:{
            type:Object,
            required:true
        },
        recentlyUsedAccountsList: {
            type: Array,
            required: true
        },
        selectedAccount:{
            type:Object,
            required:true
        },
        pageType:Int16Array,
    },
    data() {
       return{
        isContactInfoVisible:false,
        bgClasses: [
            {id: 0, text: 'bg-light-primary text-primary'},
            {id: 1, text: 'bg-light-success text-success'},
            {id: 2, text: 'bg-light-info text-info'},
            {id: 3, text: 'bg-light-danger text-danger'},
            {id: 4, text: 'bg-light-warning text-warning'},
            {id: 5, text: 'bg-light-secondary text-gray-800'},
        ],
       }
    },
    computed:{
    previewDate(){
      return (value)=>{
       if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY')
        }
      }
    },
    getRandomClass(){
        return (value)=>{ return this.bgClasses[value] ? this.bgClasses[value].text : 'bg-light-info text-info'}
    },
    getTotals() {
        return (array)=>{
            if (array) {
                let sum = 0;
                array.map(x => {
                    sum += parseFloat(x.total_balance_local.replaceAll(',', ''))
                });
                return this.$globalParseFloat(sum);
            }
        }
    },
    },
    methods:{
    getAccountBalances(item) {
        item.isCollapsed = !item.isCollapsed;
        if(item.isCollapsed) {
            const parameters = {
                session_id: this.$getUser().session_id,
                account_id:  item.id
            }; 
            axios.post('/api/Helper/GetAccountCurrencyBalances', parameters, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    if(response.data.balance.length > 0) item.balances = response.data.balance;
                    item.totals = response.data.summary;
                }
            })
            .catch((error) => {
                console.error(error);
            });
        }
    },
    selectAccount(item){
        this.$emit('selectAccount', item);
    },
    openAccountReportModal(item){
        this.$emit('openAccountReportModal',item);
    },
    }
};
</script>